
export default {
  props: {
    customWrapperStyle: {
      type: Object,
      default: () => {}
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    countDownTime: {
      type: Number,
      default: 0
    },
    formatTime: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      showTime: "",
      count: 0,
      timer: null
    }
  },
  computed: {
    defaultFormatTime() {
      return this.$i18n.locale === "zh_HK"
        ? { hour: "小時 ", minute: "分 ", second: "秒" }
        : { hour: "h ", minute: "m ", second: "s" }
    }
  },
  watch: {
    countDownTime: {
      handler(newVal) {
        this.startCountDown(newVal)
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    startCountDown(time) {
      this.clearTimer()
      this.count = Math.max(Number(time) || 0, 0)

      this.updateCountDown()

      if (this.count <= 0) {
        this.$emit("curCount", this.count)
        return
      }

      this.timer = setInterval(() => {
        this.count -= 1000

        if (this.count <= 0) {
          this.count = 0
          this.updateCountDown()
          this.$emit("curCount", this.count)
          this.clearTimer()
          return
        }

        this.updateCountDown()
        this.$emit("curCount", this.count)
      }, 1000)
    },

    updateCountDown() {
      this.showTime = this.contDownFun(this.count)
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    contDownFun(time) {
      const lastTime = Math.floor(time / 1000)
      const hour = Math.floor(lastTime / 3600)
      const minute = Math.floor((lastTime % 3600) / 60)
      const second = lastTime % 60

      const { hour: hSep = ":", minute: mSep = ":", second: sSep = "" } = this.formatTime || this.defaultFormatTime

      const hourTen = Math.floor(hour / 10)
      const hourUnit = hour % 10
      const minuteTen = Math.floor(minute / 10)
      const minuteUnit = minute % 10
      const secondTen = Math.floor(second / 10)
      const secondUnit = second % 10

      return `${hourTen}${hourUnit}${hSep}${minuteTen}${minuteUnit}${mSep}${secondTen}${secondUnit}${sSep}`
    }
  }
}
